import * as React from 'react';
import * as Redux from 'redux';
import { connect } from 'react-redux';
import ReactSVG from 'react-svg';
import styled from 'styled-components';
import { modalInstance } from './../Content';
import { translate } from "react-i18next";
import messageManager from './../../../utilities/messageManager';
import loading from './../../../utilities/loading';
import GhostButton from './../../../components/GhostButton';
import Spinner from './../../../components/Spinner';
import IconClose from './../../../icons/cancel2.svg';
import {
    startDrawingFaultPhoto,
    cancelDrawingFaultPhoto,
    getFaultPhotosAndVideos,
    getFaults,
} from './../../../actions/faults';
import {
    selectPhoto,
    getPhotoFaults,
    getPhotos,
} from '../../../actions/photos';
import {
    setChosenFlightById,
} from './../../../actions/flightManager';
import {
    openGallery,
} from './../../../actions/modules';

const FlexWrapper = styled.div`
    overflow-y: auto;
    max-height: 400px;
    transition: max-height 0.5s;
    padding: 0 10px;
    white-space: pre-wrap;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
`;

const Gallery = styled.div`    
    display: flex;
    flex-wrap: wrap;
`;

const Description = styled.p`
    color:  #265a9c;
    font-size: 13px;
    font-weight: 700;
    font-weight: bold;
    margin: 5px 0;
`;

const Thumbnail = styled.img`
    width: 97px;
    height: 75px;
    image-rendering: pixelated;
    padding: 2px;
`;

const ThumbnailWrapper = styled.div`
    position: relative;
    width: 100px;
    background-color: #ffffff;
    margin: 5px;
    border-radius: 5px;
    padding: ${props => props.selected ? '2px' : '2.5px'};
    border: ${props => props.selected ? '1.5px solid #265a9c' : '1px solid #ebebeb'};
    box-shadow: ${props => props.selected ? '0 1px 3px #0000004d' : 'none'};
    :hover {
        border: 1.5px solid #ccdbe8;                
        padding: 2px;
    }
`;

const DeleteFaultPhotoButton = styled.div`
    position: absolute;
    right: 5px;
    top: 5px;
    border-radius: 5px;  
    width: 20px;
    display: flex;
    justify-content: center;
    background: #ffffff80;
    :hover {
        box-shadow: inset 0 0 2px #000000;
    }
`;

const FileName = styled.div`
    padding-left: 2px;
    font-size: 14px;
    font-weight: 600;
    word-break: break-all;
`;

class FaultPhotosContainer extends React.Component {
    constructor(props) {
        super();
        this.state = {
            isDrawing: false,
        }
    }

    handleFaultPhotoClick(faultPhoto) {
        const { selected, openGallery, chosenFlight, selectPhoto, setChosenFlightById } = this.props;
        if (selected !== 'gallery') {
            openGallery();
        }

        if (!chosenFlight || chosenFlight.id !== faultPhoto.photo.projectId) {
            setChosenFlightById(faultPhoto.photo.projectId);
        }
        selectPhoto(faultPhoto.photoId);
    }

    handleAddFaultPhotoClick() {
        const { startDrawingFaultPhoto } = this.props;
        this.setState({
            isDrawing: true
        });
        startDrawingFaultPhoto();
    }

    handleDeleteFaultPhotoClick(faultPhoto) {
        const { BASE_URL, t, axiosInstance, chosenFlight, selectedFault, selectedPhotoId, getPhotoFaults, getFaultPhotosAndVideos, getFaults, getPhotos } = this.props;
        const confirmCallback = () => {
            axiosInstance.delete(`${BASE_URL}fault-photos/${faultPhoto.id}`)
                .then(() => {
                    // TODO: lepsze rozwiazanie aby nie odswiezac wszystkich danych
                    getFaults(axiosInstance);
                    getPhotos(axiosInstance, chosenFlight ? chosenFlight.id : 0);
                    getFaultPhotosAndVideos(axiosInstance, selectedFault.id);
                    getPhotoFaults(axiosInstance, selectedPhotoId);
                    messageManager.show({
                        text: t('Photo mark deleted'),
                        type: 'info',
                    });
                    loading.stop();
                })
                .catch((error) => {
                    messageManager.show({
                        type: 'error',
                        text: t(error.response.data ? error.response.data : t('Error occured while deleting photo mark')),
                    });
                    loading.stop();
                });
        }
        const cancelCallback = () => { }

        const config = {
            title: t('Do you really want to delete photo mark') + '?',
            content: <p>{t('Do you really want to delete photo mark')} ? </p>,
            confirmCallback: confirmCallback,
            cancelCallback: cancelCallback,
            confirmBtnVisible: true,
            cancelBtnVisible: true,
            confirmBtnText: t('Delete'),
            closeOnConfirm: true,
            type: 'warning',
        }
        modalInstance.customize(config);
        modalInstance.show();
    }

    componentDidUpdate(prevProps) {
        const { drawingFaultPhoto } = this.props;
        if (prevProps.drawingFaultPhoto !== drawingFaultPhoto
            && (drawingFaultPhoto === 'finished' || drawingFaultPhoto === 'canceled')) {
            this.setState({
                isDrawing: false
            });
        }
    }

    render() {
        const { BASE_URL, faultPhotos, selectedPhotoId, t, editMode } = this.props;
        const { isDrawing } = this.state;
        const token = localStorage.getItem('token');

        return (
            <FlexWrapper
                onClick={(e) => { e.preventDefault() }}>
                <Description>
                    {t('Fault photos')}:
                </Description>
                {faultPhotos === null
                    ? <Spinner />
                    : <Gallery>
                        {faultPhotos.map(faultPhoto => {
                            const url = `${BASE_URL}photos/${faultPhoto.photoId}/thumbnail?token=${token}`
                            return (
                                <ThumbnailWrapper
                                    key={`faultphoto_${faultPhoto.photoId}`}
                                    selected={faultPhoto.photoId === selectedPhotoId}
                                    onClick={() => {
                                        this.handleFaultPhotoClick(faultPhoto);
                                    }}>
                                    <Thumbnail src={url} />
                                    {editMode ? <DeleteFaultPhotoButton onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        this.handleDeleteFaultPhotoClick(faultPhoto);
                                    }}>
                                        <ReactSVG
                                            path={IconClose}
                                            title={t('Delete photo mark')}
                                            style={{
                                                fill: '#000000',
                                                width: '10px',
                                                height: '10px',
                                            }}
                                        />
                                    </DeleteFaultPhotoButton> : null}
                                    <FileName>{faultPhoto.photo.fileName}</FileName>
                                </ThumbnailWrapper>
                            )
                        })}
                        {editMode ?
                            isDrawing ?
                                <GhostButton
                                    style={{
                                        fontSize: 'small',
                                        fontWeight: 'bold',
                                        margin: '5px',
                                    }}
                                    title={t('Cancel marking')}
                                    onClick={() => {
                                        this.props.cancelDrawingFaultPhoto();
                                        this.setState({ isDrawing: false })
                                    }}>
                                    {t('Cancel marking')}
                                </GhostButton> :
                                <GhostButton
                                    disabled={!selectedPhotoId || faultPhotos.find(faultPhoto => faultPhoto.photoId === selectedPhotoId)}
                                    title={t('Mark on photo')}
                                    style={{
                                        fontSize: 'small',
                                        fontWeight: 'bold',
                                        margin: '5px',
                                    }}
                                    onClick={this.handleAddFaultPhotoClick.bind(this)}>
                                    {t('Mark on photo')}
                                </GhostButton> : null}
                    </Gallery>
                }
            </FlexWrapper >
        );
    }
};

const mapStateToProps = state => ({
    axiosInstance: state.auth.get('axiosInstance'),
    selectedFault: state.faults.get('selectedFault'),
    chosenFlight: state.flightManager.get('chosenFlight'),
    faultPhotos: state.faults.get('faultPhotos'),
    selectedPhotoId: state.photos.get('selectedPhotoId'),
    drawingFaultPhoto: state.faults.get('drawingFaultPhoto'),
    selected: state.modules.get('selected'),
    BASE_URL: state.domainProperties.get('BASE_URL'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
    startDrawingFaultPhoto,
    cancelDrawingFaultPhoto,
    selectPhoto,
    setChosenFlightById,
    getFaultPhotosAndVideos,
    getPhotoFaults,
    getPhotos,
    getFaults,
    openGallery,
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(FaultPhotosContainer));


// WEBPACK FOOTER //
// ./src/containers/content/faultsManager/FaultPhotosContainer.jsx